










































import {
  Component, PropSync, Vue,
} from 'vue-property-decorator';
import EditUserProfilePersonalityDialogViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/edit-user-profile-personality/edit-user-profile-personality-dialog-view-model';

@Component({
  name: 'EditUserProfilePersonalityDialog',
  components: {
    FlagshipProfilingStepEconomicDependents: () => import('@/vue-app/components/flagship/flagship-profiling/FlagshipProfilingStepEconomicDependents.vue'),
    FlagshipProfilingStepEmploymentSituation: () => import('@/vue-app/components/flagship/flagship-profiling/FlagshipProfilingStepEmploymentSituation.vue'),
    FlagshipProfilingStepFinancialHabits: () => import('@/vue-app/components/flagship/flagship-profiling/FlagshipProfilingStepFinancialHabits.vue'),
    EditUserProfilePersonalityInvestmentExperience: () => import('./EditUserProfilePersonalityInvestmentExperience.vue'),
  },
})
export default class EditUserProfilePersonalityDialog extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  @PropSync('componentToEdit', { type: String, required: true })
  synced_component_to_edit!: string;

  edit_user_profile_view_model = Vue.observable(
    new EditUserProfilePersonalityDialogViewModel(),
  );

  close() {
    this.synced_is_open = false;
  }

  mounted() {
    this.edit_user_profile_view_model.initialize(this.synced_component_to_edit);
  }

  reloadInvestorProfile() {
    this.$emit('reloadInformation');
    this.close();
  }
}
